import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TaxEnergyTab, TaxGrantRecord, TaxPatentRecord, TaxProfileHistory, taxEnergyPeriodsText } from './tax-profile-history';

/**
 * The body of a Tax recorded history dialog: every patent or grant as a list, newest first, or energy and emissions as
 * period tables in the shared financial report style. Place it inside company-profile-dialog.
 */
@Component({
  selector: 'tax-profile-history',
  templateUrl: './tax-profile-history.component.html',
  styleUrls: ['./tax-profile-history.component.css'],
  standalone: false,
})
export class TaxProfileHistoryComponent implements OnChanges {
  @Input() kind: TaxProfileHistory = 'patents';
  @Input() patents: TaxPatentRecord[] = [];
  @Input() grants: TaxGrantRecord[] = [];
  @Input() energy: TaxEnergyTab[] = [];

  readonly periodsText = taxEnergyPeriodsText;
  activeEnergyTab: TaxEnergyTab['id'] = 'energy';
  showChange = true;

  ngOnChanges(changes: SimpleChanges): void {
    // Open on the first tab with figures.
    if (changes['energy']) this.activeEnergyTab = this.energy.find(tab => tab.rows.length)?.id || 'energy';
  }

  get activeTab(): TaxEnergyTab | undefined {
    return this.energy.find(tab => tab.id === this.activeEnergyTab);
  }

  selectTab(id: TaxEnergyTab['id']): void {
    this.activeEnergyTab = id;
  }
}
